import { useParams } from 'react-router-dom'

export function useRequiredParams<T extends Record<string, string> = Record<string, string>>(): T {
  const params = useParams()

  const result: Record<string, string> = {}

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) {
      // eslint-disable-next-line no-console
      console.error('Missing required route parameter:', key)
      throw new Error(`Required route parameter "${key}" is missing. Check your route configuration.`)
    }
    result[key] = value as string
  }

  return result as T
}
